// Base service name
export const SERVICE_NAME = "GOOGLE_SERVICE";

// Google API
export const GAPI_LIBRARY = "https://apis.google.com/js/api.js";
export const GAPI_KEY = "AIzaSyBBFsidWL6J88hM0zC9uFA3GnyNmAvXSwU";

export const DRIVE_DISCOVERY_DOC = "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest";
export const DRIVE_FOLDER_ID = "1AkxcxlDQvbxfpeu3imytl-s1uc-_QINp";
